/**
 * Canonical constants for the WTC customer-folders Drive area.
 *
 * The customer root holds ONE folder per company (company-level — all contacts
 * at a company share it). Historically this id was copy-pasted into 5+ files
 * (`customer-folder-helpers.ts`, `CompanyDrive.tsx`, `ClientDriveTab.tsx`,
 * `SaveAttachmentsToGoogleDriveModal.types.ts`, quotes `constants.ts`). Those
 * re-export from here so there is a single source of truth.
 *
 * The root lives INSIDE a Shared Drive, so all create/copy/update calls against
 * it must pass `supportsAllDrives: true`.
 */

/** Root Drive folder that holds every company's folder (one subfolder per company). */
export const CUSTOMER_DRIVE_ROOT_FOLDER_ID =
  process.env.CUSTOMER_DRIVE_ROOT_FOLDER_ID?.trim() || "196en7iu_hwboClixVXQiqX1YUzzhD-Kz";

/**
 * Template folder cloned into each new company folder so it starts pre-configured
 * with the standard subfolder structure (03_Joint-Meetings, 04_Contracts-Master,
 * 05_Finance-Mirror, ...). The impersonated service-account subject must have at
 * least viewer access to it.
 */
export const COMPANY_FOLDER_TEMPLATE_ID =
  process.env.COMPANY_DRIVE_TEMPLATE_FOLDER_ID?.trim() || "1PqYtNodE5shA6Y0N6wq2JQ4Bm3dX3PZ_";

/**
 * Workspace user the hub service account impersonates (domain-wide delegation)
 * for company-folder provisioning/upload. MUST be a content manager on the
 * shared drive containing the customer root AND have viewer access to the
 * template folder. Overridable per environment.
 */
export const COMPANY_DRIVE_SUBJECT =
  process.env.COMPANY_DRIVE_SUBJECT?.trim() ||
  process.env.GDRIVE_QUOTE_LOOKUP_SUBJECT?.trim() ||
  "miclainkeffeler@westtn.consulting";

/** Browser URL for a Drive folder id. */
export function companyDriveFolderUrl(folderId: string): string {
  return `https://drive.google.com/drive/folders/${folderId}`;
}
